import type { Role } from "@athena/common/graphql/generated/schema";

export const roleLabelMap: Record<Role, string> = {
    USER: "User",
    COACH: "Coach",
    ADMIN: "Admin",
    ORG_ADMIN: "Org Admin",
    SUB_ORG_ADMIN: "Sub-Org Admin",
    SYSTEM: "System",
};

export const roleVariantMap: Record<Role, "sky" | "teal" | "violet" | "indigo" | "muted" | "pink" | "emerald"> = {
    USER: "sky",
    COACH: "indigo",
    ADMIN: "violet",
    ORG_ADMIN: "pink",
    // Same family as ORG_ADMIN: the same kind of role with narrower reach.
    SUB_ORG_ADMIN: "emerald",
    SYSTEM: "muted",
};
